import React, { useEffect } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import useProducts from "../../hooks/useProducts";
import Footer from "../../components/Footer";

const CategoryPage = () => {
  const { categoryId } = useParams();
  const { products, categoryName, loading, error, fetchProductsByCategory } =
    useProducts();
  const navigate = useNavigate();

  useEffect(() => {
    fetchProductsByCategory(categoryId);
  }, [categoryId, fetchProductsByCategory]);

  const ProductItemCard = ({ product }) => (
    <div
      className="bg-white rounded-lg border border-gray-200 p-4 sm:p-6 flex flex-col h-full cursor-pointer hover:shadow-lg transition-shadow duration-200"
      onClick={() => navigate(`/product-detail/${product.id}`)}
    >
      <div className="w-full h-40 bg-gray-100 rounded-lg mb-4 overflow-hidden flex items-center justify-center">
        {product.image_url ? (
          <img
            src={
              product.image_url.startsWith("uploads")
                ? `https://api.yikafoni.com/${product.image_url}`
                : product.image_url
            }
            alt={product.name}
            className="w-full h-full object-cover"
            onError={(e) => {
              e.target.style.display = "none";
            }}
          />
        ) : (
          <span className="text-gray-400 text-sm">Resim Yok</span>
        )}
      </div>
      <h3
        className="text-base font-semibold text-[#111827] mb-1 flex-grow"
        title={product.name}
      >
        {product.name}
      </h3>
      {product.unit_name && (
        <p className="text-sm text-gray-500 mt-1">{product.unit_name}</p>
      )}
    </div>
  );

  // Render anındaki state'leri logla
  console.log(
    "CategoryPage Rendering - loading:",
    loading,
    "error:",
    error,
    "products:",
    products // products dizisinin içeriğini kontrol et
  );

  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-[1320px] mx-auto px-4 sm:px-6 lg:px-8 py-8 mb-32">
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-8 gap-4">
          <div>
            <h1 className="text-xl sm:text-2xl font-semibold text-[#111827] mb-2">
              {loading ? "Yükleniyor..." : error ? "Hata" : categoryName}
            </h1>
            <div className="flex items-center gap-2 text-sm">
              <Link to="/" className="text-[#6366F1] hover:underline">
                Yıkafoni
              </Link>
              <span className="text-[#9CA3AF]">/</span>
              <span className="text-[#6B7280]">
                {loading ? "..." : categoryName}
              </span>
            </div>
          </div>
          <div className="flex items-center gap-4 self-end sm:self-center">
            <div className="relative">
              <select className="appearance-none bg-white border border-[#E5E7EB] rounded-lg px-4 py-2 pr-10 text-sm text-[#111827] focus:outline-none focus:ring-2 focus:ring-[#4F46E5]">
                <option>Popüler</option>
                <option>En Yeni</option>
                <option>En Çok Değerlendirilen</option>
              </select>
              <div className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path
                    d="M4 6L8 10L12 6"
                    stroke="#6B7280"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
            </div>
            <button className="bg-[#4F46E5] text-white px-4 py-2 rounded-lg text-sm font-medium">
              Filtrele
            </button>
          </div>
        </div>

        {!loading && !error && (
          <div className="text-sm text-[#6B7280] mb-6">
            Toplam {products.length} Sonuç Gösteriliyor
          </div>
        )}

        {loading && (
          <p className="text-center text-gray-500 py-10">
            Ürünler yükleniyor...
          </p>
        )}
        {error && (
          <p className="text-center text-red-500 py-10">Hata: {error}</p>
        )}
        {!loading && !error && products.length > 0 && (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {products.map((product) => (
              <ProductItemCard key={product.id} product={product} />
            ))}
          </div>
        )}
        {!loading && !error && products.length === 0 && (
          <p className="text-center text-gray-500 py-10">
            Bu kategoride ürün bulunamadı.
          </p>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default CategoryPage;
